module.exports = __webpack_public_path__ + "img/3be23c0.png";